export default "__VITE_ASSET__uqtQwnZH__"